/**
 * Once we can verify that the BE is injecting the environment config into
 * EVERY page, this can be removed. At that point our build scripts can stop
 * injecting these and we can have 1 build that runs on any environment.
 */
const compiledEnvironment = {
  /* eslint-disable no-restricted-syntax */
  cdnURL: process.env.CDN_URL,
  hsHost: process.env.HS_DOMAIN,
  hfHost: process.env.HF_DOMAIN,
  sentryDSN: process.env.HS_SENTRY_DSN,
  sentryEnvironment: process.env.SENTRY_ENVIRONMENT,
  /* eslint-enable no-restricted-syntax */
};

const runtimeEl = document.getElementById('hs-env');
const runtimeEnvironment: typeof compiledEnvironment = runtimeEl == null
  ? compiledEnvironment
  : JSON.parse(runtimeEl.innerHTML);

export const {
  cdnURL,
  hsHost,
  hfHost,
  sentryDSN,
  sentryEnvironment,
} = runtimeEnvironment;
